// extracted by mini-css-extract-plugin
export default {"skeleton-loader":"skeleton-loader_skeleton-loader__0Wwwj"};